<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
  <div class="container3 cent" style="margin-top:60px !important" *ngIf="adoption && adoption.user_id == userid ; else nomanage">
    <div class="row" >
    <div class="col-sm-4 col-md-6 col-lg-3 col-xl-3 text-center">
      <div class="card" style="max-height:350px">
        <img src="https://passport.petcart.in/images/adoption/{{adoption.photo}}"  style="height:100%; width:100%">
      </div>
    </div>
    <div class="col-sm-4 col-md-6 col-lg-5 col-xl-5 " style="font-style: open sans">
      <p><span><h4>{{ adoption.pet_name }}</h4></span></p>
      <span style="color:#9b7544; overflow-wrap: break-word;"><h4><strong>{{adoption.description }}</strong></h4></span>
      <p><span>Gender: {{adoption.gender }}</span></p>
      <p><span>Age: {{adoption.age }}</span></p>
      <p><span>Color: {{adoption.color }}</span></p>
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" *ngIf="breed">
          <div *ngFor="let datab of breed">
            <span style="text-transform: capitalize" *ngIf="datab.id == adoption.breed_id">Breed: {{datab.name}}</span>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" *ngIf="city">
            <div *ngFor="let data of city">
                <span style="text-transform: capitalize" *ngIf="data.id == adoption.city_id">city: {{data.location}}</span>
              </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" *ngIf="location">
              <div *ngFor="let dataa of location">
                  <span style="text-transform: capitalize" *ngIf="dataa.id == adoption.location_id">location: {{dataa.location}}</span>
                </div>
            </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
      <div class="col-12 text-center">
        <span style="font-style: open sans; font-size:22px; text-decoration: underline"><strong>
        Document Or Certification
        </strong></span>
      </div>
      <p class="text-center"><span>Neutered : {{adoption.neutered }}</span></p>
      <p  class="text-center"><span>Vaccinated  : {{adoption.vaccination }}</span></p>
      <p  class="text-center"><span>kci Certification: {{adoption.kci }}</span></p>
      <p  class="text-center"><span style="color:#9b7544">status: {{adoption.adoptionstatus }}</span></p>
    </div>
    </div>
    <div class="row" *ngIf="adoption.adoptionstatus === 'waiting For Verification'">
      <div class="col-12 text-right" style="margin-top:2%; margin-bottom:1%">
        <span  style="color:#9b7544; overflow-wrap: break-word;"><strong>
        ** This Post wll be published after verification. Verificaion is expected to be complete with in 24 hours
        </strong></span>
      </div>
    </div>
    <div class="row" *ngIf="adoption.adoptionstatus === 'pending_otp'">
        <div class="col-12 text-right" style="margin-top:2%; margin-bottom:1%">
          <span  style="color:#9b7544; overflow-wrap: break-word;"><strong>
          ** To Publish This Post You have verify your mobile number
          </strong></span>
        </div>
      </div>
    <mat-tab-group>
        <mat-tab label="Documents" >
            <div class="row" *ngIf="adoptiondoc && adoptiondoc.length> 0;else nodocument">
                <div class="col-12"  *ngFor=" let docs of adoptiondoc">
                  <div class="row" style="margin-top: 2%; color:#9b7544;font-size:20px;font-style: open sans">
                  <div class="col-sm-12 col-md-3 col-lg-3 col-xl-4 text-center"
                   *ngIf= "getFileExtension(docs.path) === 'png' || getFileExtension(docs.path) === 'jpg'  ||
                    getFileExtension(docs.path) === 'bmp' || getFileExtension(docs.path) === 'gif';
                    else textimage">
                    <img class="avatar1 "  src="https://passport.petcart.in/images/adoption/{{docs.path}}">
                  </div>
                  <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5 text-center">
                      <p><span><strong>Docs Type: {{docs.document_type}}</strong></span></p>
                  </div>
                  <div class="col-sm-2 col-md-3 col-lg-3 col-xl-3 text-center">
                      <a href="https://passport.petcart.in/images/petimages/{{docs.path}}" download>
                        <mat-icon>file_download</mat-icon> Download  </a>
                   </div>
                </div>
              </div>
               </div>
          </mat-tab>
          <mat-tab label="Request for Adoption"  *ngIf="adoption.adoptionstatus === 'published'">
              <div class="row" *ngIf="adoptionrequest && adoptionrequest.length> 0;else norequest">
                <div class="col-12 ">
                  <div class="card-header">

                         <p class="text-right"><strong> Request For This Adoption : {{totalrequest}}</strong></p>
                     </div>
                </div>
              </div>
              <div class="row"  *ngIf="adoptionrequest && adoptionrequest.length> 0">
                  <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4" *ngFor="let data of adoptionrequest">
              <div class="card" style="margin-top: 3%;margin-bottom:2%">
                  <div class="card-header">
                   <div class="row">
                     <div class="col-6 text-left">
                      <img class="avatar" src = "https://passport.petcart.in/images/userimgs/{{photo['id'+data.contacteduser_id]}}">
                     </div>
                     <div class="col-6 text-right">
                        <h4 style="font-style: open sans"> {{requsername['id'+data.contacteduser_id]}}</h4>
                      </div>
                   </div>
                  </div>
                  <div class="card-body">
                    <p class="text-center">Requested Time: {{data.created_at | slice:0:16}}</p>
                    <p class="text-center" style="overflow-wrap: break-word">Status: {{data.status}}</p>
                    <p class="text-center" style="overflow-wrap: break-word">sharecontact: {{data.sharecontact}}</p>
                    </div>
                    <div class="card-footer">
                      <div class="row">
                        <div class="col-12 text-right">
                          <button class="btn btn-secondary " *ngIf="data.status ==='requested';"
                          (click)="manageRequest(data.id,data.contacteduser_id)">Manage</button>
                          <button class="btn btn-secondary " *ngIf="data.status !=='requested';"
                          (click)="manageRequest(data.id,data.contacteduser_id)">View</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                  </div>
            </mat-tab>
            </mat-tab-group>
            <div class="row" style="margin-top:3%">
                <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8 text-center" >
                  <button class="bt btn-success btn-block" *ngIf="adoption &&
                  adoption.adoptionstatus ==='published'" (click)=" changeAdoptionStatus()">
                    Already Adopted?? Click Here To Change Status
                  </button>
                  <button class="bt btn-success btn-block" *ngIf="adoption &&
                  adoption.adoptionstatus ==='pending_otp'" (click)=" verifyMobile()">
                    verify Mobile Number
                  </button>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center" style="margin-top: 2px; margin-bottom: 2px">
                    <button class="bt btn-success2 btn-block" (click)="redirectBack()">
                        Go back
                      </button>
                 </div>
              </div>
  </div>
  <ng-template #nomanage>
    <div class="container3 cent">
      <div class="row" *ngIf="adoption">
          <div class="col-sm-4 col-md-6 col-lg-3 col-xl-3 text-center">
            <div class="card" style="max-height:350px">
              <img src="https://passport.petcart.in/images/adoption/{{adoption.photo}}"  style="height:100%; width:100%">
            </div>
          </div>
          <div class="col-sm-4 col-md-6 col-lg-5 col-xl-5 " style="font-style: open sans">
            <p><span><h4>{{ adoption.pet_name }}</h4></span></p>
            <p style="color:#9b7544"><span style="color:#9b7544; overflow-wrap: break-word;"><h4><strong>{{adoption.description }}</strong></h4></span></p>
            <p><span>Gender: {{adoption.gender }}</span></p>
            <p><span>Age: {{adoption.age }}</span></p>
            <p><span>Color: {{adoption.color }}</span></p>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" *ngIf="breed">
                  <div *ngFor="let datab of breed">
                    <span style="text-transform: capitalize" *ngIf="datab.id == adoption.breed_id">Breed: {{datab.name}}</span>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" *ngIf="city">
                    <div *ngFor="let data of city">
                        <span style="text-transform: capitalize" *ngIf="data.id == adoption.city_id">city: {{data.location}}</span>
                      </div>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4" >
                      <div *ngFor="let data of location">
                          <span style="text-transform: capitalize" *ngIf="data.id == adoption.location_id">location: {{data.location}}</span>
                        </div>
                    </div>
              </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <div class="col-12">
              <span style="font-style: open sans; font-size:22px; text-decoration: underline"><strong>
              Document Or Certification
              </strong></span>
            </div>
            <p><span>Neutered : {{adoption.neutered }}</span></p>
            <p><span>Vaccinated  : {{adoption.vaccination }}</span></p>
            <p><span>kci Certification: {{adoption.kci }}</span></p>
            <p><span style="color:#9b7544">status: {{adoption.adoptionstatus }}</span></p>
          </div>
          </div>
          <ngb-accordion  #acc="ngbAccordion" style="margin: 5px">
              <ngb-panel title="Available Document">
                <ng-template ngbPanelContent>
                  <div class="row" *ngIf="adoptiondoc && adoptiondoc.length> 0;else nodocument">
                      <div class="col-12"  *ngFor=" let docs of adoptiondoc">
                        <div class="row" style="margin-top: 2%; color:#9b7544;font-size:20px;font-style: open sans">
                        <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center "
                         *ngIf= "getFileExtension(docs.path) === 'png' || getFileExtension(docs.path) === 'jpg'  ||
                          getFileExtension(docs.path) === 'bmp' || getFileExtension(docs.path) === 'gif';
                          else textimage">
                          <img class="avatar1 "  src="https://passport.petcart.in/images/adoption/{{docs.path}}">
                        </div>
                        <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5 text-center">
                            <p><span><strong>Docs Type: {{docs.document_type}}</strong></span></p>
                        </div>
                        <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center">
                            <a href="https://passport.petcart.in/images/petimages/{{docs.path}}" download>
                              <mat-icon>file_download</mat-icon> Download  </a>
                         </div>
                      </div>
                    </div>
                     </div>
                    </ng-template>
              </ngb-panel>
              </ngb-accordion>
              <div class="row" >
                <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8 text-center" >
                  <button class="bt btn-success btn-block" (click)="goToAdoptionrequestForm(adoption.id)" *ngIf="adoprequestflag == 0; else alreadysent">
                    Show Interest in Adoption
                  </button>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4 text-center" style="margin-top: 2px; margin-bottom: 2px">
                    <button class="bt btn-success2 btn-block" (click)="redirectBack()">
                        Go Back
                      </button>
                 </div>
              </div>
            </div>
  </ng-template>

  <ng-template #textimage>
      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4 text-center">
          <img class="avatar1 " src="https://passport.petcart.in/images/petimages/doc.png">
      </div>

  </ng-template>
  <ng-template #nodocument>
    <div class="row">
      <div class="col-12 text-center">
        <h4 style="font-style:open sans"><strong>No Documents Uploaded for this Post</strong></h4>
      </div>
    </div>
  </ng-template>
  <ng-template #norequest>
      <div class="row">
        <div class="col-12 text-center">
          <h4 style="font-style:open sans"><strong>No Request Found For This Post</strong></h4>
        </div>
      </div>
    </ng-template>
<ng-template #alreadysent>

       <span style="color:#9b7544; overflow-wrap: break-word"><h4>You have already sent Adoption Request for this post.</h4></span>

</ng-template>
